export default __webpack_public_path__ + "static/media/img-09.18754193.jpg";